<template>
  <div class="index" v-cloak>
    <section class="list-part-refer part main-top">
      <!-- <img style="width:100%; height:470px;" /> -->
      <div
        class="swiper"
        :style="{ background: 'url(' + categoryInfo.banner + ')' }"
      >
        <div class="part-inner">
          <div class="upper">
            <div class="card-wrapper">
              <div class="row row2">
                <div class="home-title">
                  <span
                    style="position: relative;z-index:9;display:block"
                    class="home-title-big animate-home-title-big"
                    >{{ categoryInfo.cate_name }}</span
                  >
                  <span
                    style="position: relative;z-index:9;display:block"
                    class="home-title-small animate-home-title-big"
                    >创孵企业服务平台</span
                  >
                  <span class="a-smail">早注册·早保护</span>
                </div>
                <Tabs
                  value="name3"
                  :animated="false"
                  class="write_what trade-com"
                >
                  <!-- <TabPane label="商标查询服务" name="name3"> -->
                  <div class="list-part-refer-con">
                    <div class="form-top">
                      <div class="score liaison-trademark">
                        <Input
                          v-model="trademark.keyword"
                          placeholder="商标名称"
                        />

                        <div
                          class="liaison-btn bg-color-red liaison-btn-one"
                          @click="queryTrademark"
                        >
                          免费查询
                        </div>
                        <div @click="redirect" class="liaison-btn bg-color-red">
                          注册商标
                        </div>
                      </div>
                      <h3 class="card-title">
                        <span>
                          用户138****5898提交办理
                        </span>
                      </h3>
                    </div>
                  </div>
                  <!-- </TabPane> -->
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <h3 class="banner-title animate-mark-register-title animated fadeInUp">
        {{ categoryInfo.cate_name }}
      </h3>
      <div class="banner-desc animate-mark-register-subtitle animated fadeInUp">
        <span>{{ categoryInfo.cate_intro }}</span>
      </div>
    </section>
    <div class="home-body">
      <section class="my-slider">
        <section class="box">
          <div class="list">
            <div class="my-slider-right">
              <div
                class="slider-right-item"
                v-for="(todo, index) in categoryInfo.hot_product"
                :key="index"
                @mouseenter="addClass(index)"
                v-bind:class="{ blue: index == current }"
              >
                <router-link
                  :to="todo.id ? '/detail/' + todo.id : todo.url"
                  tag="a"
                  class="item -active"
                >
                  <div class="icon-group">
                    <div class="register-text">{{ todo.store_name }}</div>
                  </div>

                  <div class="list-group">
                    <div class="intro-zizhu desc-zizhu">{{ todo.keyword }}</div>

                    <div class="intro-zizhu desc-zizhu">
                      {{ todo.store_info }}
                    </div>
                  </div>
                  <div class="register-price sbsqfw-zizhu-price">
                    <span class="price-little">￥</span>
                    {{ todo.price }}
                  </div>
                  <div class="register-price not-price">
                    <!-- <span class="price-little">￥</span>
                    {{ todo.ot_price }}
                    <span class="price-little">起</span> -->
                  </div>
                  <div class="register-handle">立即办理</div>
                </router-link>
              </div>
            </div>
          </div>
        </section>
      </section>

      <section>
        <h3 class="banner-title animate-mark-register-title animated fadeInUp">
          其它商标服务
        </h3>
        <div
          class="banner-desc animate-mark-register-subtitle animated fadeInUp"
        >
          <span>专家团队，为你排忧解难</span>
        </div>
      </section>

      <section
        class="gs-zx-bg"
        v-for="(class_item, class_index) in categoryInfo.child"
        :key="class_index"
      >
        <section class="part one list-part-product">
          <div class="part-inner">
            <div class="upper">
              <div class="title">
                <!-- <h2>{{ column.fastInfo }}</h2> -->
                <h3>
                  <div>{{ column.fastInfo }}</div>
                  <div class="cate-name">{{ class_item.cate_name }}</div>
                </h3>
                <div
                  class="upper-img"
                  :class="'cc_' + ((class_index % 3) + 1)"
                ></div>
              </div>
              <div class="card-wrapper">
                <div class="row row1">
                  <router-link
                    class="card big"
                    v-for="(item, index) in class_item.products"
                    :key="index"
                    :to="item.id ? '/detail/' + item.id : item.url"
                    tag="a"
                  >
                    <div class="inner-wrapper">
                      <h4 class="card-name">
                        <span>{{ item.store_name }}</span>
                        <!-- <i>{{ item.is_self ? "自营" : "非自营" }}</i> -->
                      </h4>
                      <p class="card-desc">{{ item.store_info }}</p>
                      <p class="card-desc" v-if="item.keyword != '#'">
                        {{ item.keyword }}
                      </p>
                      <p class="card-price">
                        <i class="mon-fl">￥</i>
                        <span class="number">{{ item.price }}</span>
                        <span class="fs">{{ item.unit_name }}</span>
                      </p>
                    </div>
                    <div class="inner-wrapper cover">
                      <h4 class="card-name">
                        <span>{{ item.store_name }}</span>
                        <!-- <i>{{ item.is_self ? "自营" : "非自营" }}</i> -->
                      </h4>
                      <p class="card-desc">{{ item.store_info }}</p>
                      <p class="card-desc" v-if="item.keyword != '#'">
                        {{ item.keyword }}
                      </p>
                      <p class="card-price">
                        <i class="mon-fl">￥</i>
                        <span class="number">{{ item.price }}</span>
                        <span class="fs">{{ item.unit_name }}</span>
                      </p>
                      <p class="see-now">
                        立即查看
                        <Icon type="ios-arrow-thin-right"></Icon>
                        <Icon type="arrow-down-b"></Icon>
                      </p>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </div>

    <div class="banner-main">
      <div
        class="home-service-good home-service-good-animate"
        v-if="typeof categoryInfo.info_category[0] != 'undefined'"
      >
        <div
          class="service-good-title animate-service-good-title animated fadeInUp"
        >
          {{
            typeof categoryInfo.info_category[0].title != "undefined"
              ? categoryInfo.info_category[0].title
              : ""
          }}
        </div>
        <div
          class="service-good-content animate-service-good-content animated fadeInUp"
        >
          <ul>
            <li
              v-if="
                typeof categoryInfo.info_category[0].info[0] != 'undefined'
                  ? true
                  : false
              "
            >
              <p
                class="ticp ticp-icon-hangyeneigaoxingjiabi service-content-title-icon"
              >
                <img
                  :src="categoryInfo.info_category[0].info[0].image_input[0]"
                  style="weight: "
                />
              </p>
              <p></p>
              <p class="service-content-title">
                {{
                  typeof categoryInfo.info_category[0].info[0].title !=
                  "undefined"
                    ? categoryInfo.info_category[0].info[0].title
                    : ""
                }}
              </p>
              <p></p>
              <p
                class="service-conten-little"
                v-html="
                  delHtmlTag(
                    typeof categoryInfo.info_category[0].info[0].content !=
                      'undefined'
                      ? categoryInfo.info_category[0].info[0].content
                      : ''
                  )
                "
              ></p>
              <p></p>
            </li>
            <li
              class="li-center"
              v-if="
                typeof categoryInfo.info_category[0].info[1] != 'undefined'
                  ? true
                  : false
              "
            >
              <p
                class="ticp ticp-icon-duozhongfuwugongninxuanze service-content-title-icon-user"
                style="margin-top: 92px"
              ></p>
              <p>
                <img
                  :src="categoryInfo.info_category[0].info[1].image_input[0]"
                  style="weight: "
                />
              </p>
              <p class="service-content-title">
                {{
                  typeof categoryInfo.info_category[0].info[1].title !=
                  "undefined"
                    ? categoryInfo.info_category[0].info[1].title
                    : ""
                }}
              </p>
              <p></p>
              <p
                class="service-conten-little"
                v-html="
                  delHtmlTag(
                    typeof categoryInfo.info_category[0].info[1].content !=
                      'undefined'
                      ? categoryInfo.info_category[0].info[1].content
                      : ''
                  )
                "
              ></p>
              <p></p>
            </li>
            <li
              v-if="
                typeof categoryInfo.info_category[0].info[2] != 'undefined'
                  ? true
                  : false
              "
            >
              <p
                class="ticp ticp-icon-zhucepinggudifengxian service-content-title-icon"
                v-if="
                  typeof categoryInfo.info_category[0].info[2] != 'undefined'
                "
              >
                <img
                  :src="categoryInfo.info_category[0].info[2].image_input[0]"
                  style="weight: "
                />
              </p>
              <p></p>
              <p class="service-content-title">
                {{
                  typeof categoryInfo.info_category[0].info[2].title !=
                  "undefined"
                    ? categoryInfo.info_category[0].info[2].title
                    : ""
                }}
              </p>
              <p></p>
              <p
                class="service-conten-little"
                v-html="
                  delHtmlTag(
                    typeof categoryInfo.info_category[0].info[2].content !=
                      'undefined'
                      ? categoryInfo.info_category[0].info[2].content
                      : ''
                  )
                "
              ></p>
              <p></p>
            </li>
          </ul>
          <ul>
            <li
              v-if="
                typeof categoryInfo.info_category[0].info[3] != 'undefined'
                  ? true
                  : false
              "
            >
              <p
                class="ticp ticp-icon-liuchengjianhuazhucegaoxiao service-content-title-gx"
                v-if="
                  typeof categoryInfo.info_category[0].info[3] != 'undefined'
                "
              >
                <img
                  :src="categoryInfo.info_category[0].info[3].image_input[0]"
                  style="weight: "
                />
              </p>
              <p></p>
              <p class="service-content-title">
                {{
                  typeof categoryInfo.info_category[0].info[3].title !=
                  "undefined"
                    ? categoryInfo.info_category[0].info[3].title
                    : ""
                }}
              </p>
              <p></p>
              <p
                class="service-conten-little"
                v-html="
                  delHtmlTag(
                    typeof categoryInfo.info_category[0].info[3].content !=
                      'undefined'
                      ? categoryInfo.info_category[0].info[3].content
                      : ''
                  )
                "
              ></p>
              <p></p>
            </li>
            <li
              class="li-center"
              style="width: 340px"
              v-if="
                typeof categoryInfo.info_category[0].info[4] != 'undefined'
                  ? true
                  : false
              "
            >
              <p
                class="ticp ticp-icon-xiaoshijisushenbao service-content-title-gx"
              >
                <img
                  :src="categoryInfo.info_category[0].info[4].image_input[0]"
                  style="weight: "
                />
              </p>
              <p></p>
              <p class="service-content-title">
                {{
                  typeof categoryInfo.info_category[0].info[4].title !=
                  "undefined"
                    ? categoryInfo.info_category[0].info[4].title
                    : ""
                }}
              </p>
              <p></p>
              <p
                class="service-conten-little"
                v-html="
                  delHtmlTag(
                    typeof categoryInfo.info_category[0].info[4].content !=
                      'undefined'
                      ? categoryInfo.info_category[0].info[4].content
                      : ''
                  )
                "
              ></p>
              <p></p>
            </li>
            <li
              v-if="
                typeof categoryInfo.info_category[0].info[5] != 'undefined'
                  ? true
                  : false
              "
            >
              <p
                class="ticp ticp-icon-shenbaojindushishizhangwo service-content-title-zw"
              >
                <img
                  :src="categoryInfo.info_category[0].info[5].image_input[0]"
                  style="weight: "
                />
              </p>
              <p></p>
              <p class="service-content-title">
                {{
                  typeof categoryInfo.info_category[0].info[5].title !=
                  "undefined"
                    ? categoryInfo.info_category[0].info[5].title
                    : ""
                }}
              </p>
              <p></p>
              <p
                class="service-conten-little"
                v-html="
                  delHtmlTag(
                    typeof categoryInfo.info_category[0].info[5].content !=
                      'undefined'
                      ? categoryInfo.info_category[0].info[5].content
                      : ''
                  )
                "
              ></p>
              <p></p>
            </li>
          </ul>
        </div>
        <!-- <div class="company_but">
          <button data-v-5e7337c8="" type="button" class="go-button">
            <span data-v-5e7337c8="">免费获取代账方案及价格</span>
          </button>
        </div> -->
      </div>
      <div
        class="zc-important"
        v-if="typeof categoryInfo.info_category[1] != 'undefined'"
      >
        <div class="banner-title animate-zc-important-title animated fadeInUp">
          {{
            typeof categoryInfo.info_category[1].title != "undefined"
              ? categoryInfo.info_category[1].title
              : ""
          }}
        </div>
        <div class="explain animate-zc-important-subtitle animated fadeInUp">
          {{
            typeof categoryInfo.info_category[1].intr != "undefined"
              ? categoryInfo.info_category[1].intr
              : ""
          }}
        </div>
        <div
          class="zc-import-content animate-zc-import-content animated fadeInUp"
          v-if="typeof categoryInfo.info_category[1].info != 'undefined'"
        >
          <div class="zc-import-content-left">
            <template
              v-for="(item, index) in categoryInfo.info_category[1].info"
            >
              <p
                :key="index"
                class="zcsb-important-btn"
                @mousemove="hoverReason(index)"
                :class="{ '-active': index == active }"
              >
                <i></i
                ><span>{{
                  typeof item.title != "undefined" ? item.title : ""
                }}</span>
              </p>
            </template>
          </div>
          <div
            class="zc-import-content-right"
            v-if="typeof categoryInfo.info_category[1].info != 'undefined'"
          >
            <template
              v-for="(item, index) in categoryInfo.info_category[1].info"
            >
              <div
                :class="[
                  { '-active-content': index == active },
                  'title-content title_content_' + index
                ]"
                v-show="index == active"
                :key="index"
              >
                <div class="left">
                  <p class="left-title-vice">
                    {{ item.synopsis ? item.synopsis : "" }}
                  </p>
                  <p class="left-content">
                    {{ item.content ? delHtmlTag(item.content) : "" }}
                  </p>
                </div>
                <div class="right animate-zc-import-content-img">
                  <img
                    v-if="
                      typeof item.image_input[0] != 'undefined' ? true : false
                    "
                    :src="item.image_input[0]"
                  />
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div
        class="zc-industry"
        v-if="
          typeof categoryInfo.info_category[2] != 'undefined'
            ? categoryInfo.info_category[2]
            : ''
        "
      >
        <div class="banner-title animate-zc-industry-title">
          {{
            typeof categoryInfo.info_category[2].title != "undefined"
              ? categoryInfo.info_category[2].title
              : ""
          }}
        </div>
        <div class="explain animate-zc-industry-subtitle">
          {{
            typeof categoryInfo.info_category[2].intr != "undefined"
              ? categoryInfo.info_category[2].intr
              : ""
          }}
        </div>
        <div class="ct-industry animate-zc-industry-content">
          <template
            v-if="typeof categoryInfo.info_category[2].info != 'undefined'"
          >
            <ul class="one-industry one-industry-one">
              <template
                v-for="(item,
                index) in categoryInfo.info_category[2].info.slice(0, 5)"
              >
                <li
                  :class="[{ '-active': item.id == reActiveId }, 'ct-li one']"
                  :key="item.id"
                  @mousemove="
                    changeReActive(
                      item,
                      index,
                      categoryInfo.info_category[2].info.slice(0, 5)
                    )
                  "
                  :style="{
                    'margin-right':
                      perId == item.id || item.id == reActiveId ? '0' : '24px'
                  }"
                >
                  <div>
                    <p :class="[skk[index], 'logo-industry']"></p>
                    <p class="title">
                      {{ typeof item.title != "undefined" ? item.title : "" }}
                    </p>
                  </div>
                </li>
              </template>
            </ul>
            <template
              v-for="item in categoryInfo.info_category[2].info.slice(0, 5)"
            >
              <div
                :class="[
                  { 'ct-box-content-active': reActiveId == item.id },
                  'ct-box-content'
                ]"
                :key="item.id"
              >
                <div v-html="item.content"></div>
              </div>
            </template>
          </template>
          <template
            v-if="categoryInfo.info_category[2].info.slice(5, 10).length != 0"
          >
            <ul class="one-industry one-industry-two">
              <template
                v-for="(item,
                index) in categoryInfo.info_category[2].info.slice(5, 10)"
              >
                <li
                  :class="[{ '-active': item.id == reActiveId }, 'ct-li one']"
                  :key="item.id"
                  @mousemove="
                    changeReActive(
                      item,
                      index,
                      categoryInfo.info_category[2].info.slice(5, 10)
                    )
                  "
                  :style="{
                    'margin-right':
                      perId == item.id || item.id == reActiveId ? '0' : '24px'
                  }"
                >
                  <div>
                    <p :class="[skk[index], 'logo-industry']"></p>
                    <p class="title">
                      {{ typeof item.title != "undefined" ? item.title : "" }}
                    </p>
                  </div>
                </li>
              </template>
            </ul>
            <template
              v-for="item in categoryInfo.info_category[2].info.slice(5, 10)"
            >
              <div
                :class="[
                  { 'ct-box-content-active': reActiveId == item.id },
                  'ct-box-content'
                ]"
                :key="item.id"
              >
                <div v-html="item.content"></div>
              </div>
            </template>
          </template>
          <template
            v-if="categoryInfo.info_category[2].info.slice(10, 15).length != 0"
          >
            <ul class="one-industry one-industry-three">
              <template
                v-for="(item,
                index) in categoryInfo.info_category[2].info.slice(10, 15)"
              >
                <li
                  :class="[{ '-active': item.id == reActiveId }, 'ct-li one']"
                  :key="item.id"
                  @mousemove="
                    changeReActive(
                      item,
                      index,
                      categoryInfo.info_category[2].info.slice(10, 15)
                    )
                  "
                  :style="{
                    'margin-right':
                      perId == item.id || item.id == reActiveId ? '0' : '24px'
                  }"
                >
                  <div>
                    <p :class="[skk[index], 'logo-industry']"></p>
                    <p class="title">
                      {{ typeof item.title != "undefined" ? item.title : "" }}
                    </p>
                  </div>
                </li>
              </template>
            </ul>
            <template
              v-for="item in categoryInfo.info_category[2].info.slice(10, 15)"
            >
              <div
                :class="[
                  { 'ct-box-content-active': reActiveId == item.id },
                  'ct-box-content'
                ]"
                :key="item.id"
              >
                <div v-html="item.content"></div>
              </div>
            </template>
          </template>
          <template
            v-if="categoryInfo.info_category[2].info.slice(15, 20).length != 0"
          >
            <ul class="one-industry one-industry-four">
              <template
                v-for="(item,
                index) in categoryInfo.info_category[2].info.slice(15, 20)"
              >
                <li
                  :class="[{ '-active': item.id == reActiveId }, 'ct-li one']"
                  :key="item.id"
                  @mousemove="
                    changeReActive(
                      item,
                      index,
                      categoryInfo.info_category[2].info.slice(15, 20)
                    )
                  "
                  :style="{
                    'margin-right':
                      perId == item.id || item.id == reActiveId ? '0' : '24px'
                  }"
                >
                  <div>
                    <p :class="[skk[index], 'logo-industry']"></p>
                    <p class="title">
                      {{ typeof item.title != "undefined" ? item.title : "" }}
                    </p>
                  </div>
                </li>
              </template>
            </ul>
            <template
              v-for="item in categoryInfo.info_category[2].info.slice(15, 20)"
            >
              <div
                :class="[
                  { 'ct-box-content-active': reActiveId == item.id },
                  'ct-box-content'
                ]"
                :key="item.id"
              >
                <div v-html="item.content"></div>
              </div>
            </template>
          </template>
        </div>
      </div>
      <div
        class="home-liucheng"
        v-if="typeof categoryInfo.info_category[3] != 'undefined'"
      >
        <div class="banner-title animate-home-liucheng-title">
          {{
            typeof categoryInfo.info_category[3].title != "undefined"
              ? categoryInfo.info_category[3].title
              : ""
          }}
        </div>
        <div
          class="img-box"
          :style="{
            background:
              'url(' +
              (typeof categoryInfo.info_category[3].info[0].image_input[0] !=
              'undefined'
                ? categoryInfo.info_category[3].info[0].image_input[0]
                : '') +
              ')',
            'background-size': '1920px 680px',
            'background-position': 'center'
          }"
        ></div>
      </div>
      <div
        class="home-problem"
        v-if="typeof categoryInfo.info_category[4] != 'undefined'"
      >
        <div class="banner-title animate-home-problem-title">
          {{
            typeof categoryInfo.info_category[4].title != "undefined"
              ? categoryInfo.info_category[4].title
              : ""
          }}
        </div>
        <div class="explain animate-home-problem-subtitle">
          {{
            typeof categoryInfo.info_category[4].intr != "undefined"
              ? categoryInfo.info_category[4].intr
              : ""
          }}
        </div>
        <ul
          class="animate-home-problem-content"
          v-if="categoryInfo.info_category[4].info.length > 0"
        >
          <template
            v-for="(item, index) in categoryInfo.info_category[4].info.slice(
              0,
              3
            )"
          >
            <li :key="index" :class="{ 'question-top': index > 0 }">
              <div>
                {{ typeof item.title != "undefined" ? item.title : "" }}
              </div>
              <div v-html="item.content"></div>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {
  messageSubmit,
  getCompanyParam,
  getTrademarkParam,
  getClassInfo
} from "@api/public";
import { trim } from "@utils";
import { required, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import "@assets/css/class.css";
import "@assets/css/class.css";

let vm = null; // eslint-disable-line no-unused-vars
export default {
  name: "Index",
  metaInfo() {
    return {
      title: this.seo_title,
      meta: this.metaData
    };
  },
  components: {
    Map
  },
  props: {},
  data: function() {
    return {
      seo_title: "",
      metaData: [],
      banner: [],
      category: [],
      amount: [],
      roll: [],
      newly: [],
      develop: [],
      column: [],
      start: [],
      hot: [],
      option: [],
      partner: [],
      message: {
        comment: "",
        option: "",
        contact: ""
      },
      thisoption: "",
      essential: "",
      current: 1,
      todos: "",
      companyInfo: {
        // cityOpt: [],
        companyKeyword: "",
        industryType: "",
        orgType: "",
        companyCity: ""
        // cityLabel: [],
      },
      trademark: {
        keyword: ""
      },
      companyCity: [],
      industryType: [],
      orgType: [],
      trademark_redirect: "",
      classId: 12,
      categoryInfo: () => {},
      active: 0,
      reActiveId: 0,
      perId: 0,
      skk: [
        "img-one",
        "img-two",
        "img-three",
        "img-four",
        "img-five",
        "img-six",
        "img-seven",
        "img-eight",
        "img-nine",
        "img-ten",
        "img-eleven",
        "img-twelve",
        "img-thirteen",
        "img-fourteen",
        "img-fifteen",
        "img-sixteen",
        "img-seventeen",
        "img-eighteen",
        "img-nineteen",
        "img-twenty"
      ]
    };
  },
  created() {
    vm = this;
  },
  mounted: function() {
    this.getClassInfo();
    this.getCompanyParam();
    this.getTrademarkParam();
  },
  methods: {
    changeReActive: function(item, cur_index, list) {
      this.perId =
        typeof list[cur_index - 1] != "undefined" ? list[cur_index - 1].id : 0;
      this.reActiveId = item.id;
    },
    hoverReason(index) {
      this.active = index;
    },
    delHtmlTag(str) {
      return str.replace(/<[^>]+>/g, ""); //正则去掉所有的html标记
    },
    getClassInfo() {
      const that = this;
      getClassInfo(this.classId)
        .then(res => {
          that.categoryInfo = res.data;
          if (
            that.categoryInfo.info_category != undefined ||
            that.categoryInfo.info_category != null
          )
            that.categoryInfo.info_category.sort((item, item2) => {
              if (item["sort"] < item2["sort"]) return 1;
              else if (item["sort"] > item2["sort"]) return -1;
              else return 0;
            });
        })
        .catch(err => {
          console.log(err);
        });
    },
    redirect() {
      this.$router.push({ path: this.trademark_redirect });
    },
    /**
     * 获取公司核名所需数据
     */
    getCompanyParam() {
      getCompanyParam().then(res => {
        this.$set(this, "companyCity", res.data.companyCity);
        this.$set(this, "industryType", res.data.industryType);
        this.$set(this, "orgType", res.data.orgType);
        // 默认选中第一个
        this.companyInfo.companyCity = res.data.companyCity[0].City;
        this.companyInfo.industryType = res.data.industryType[0].industry;
        this.companyInfo.orgType = res.data.orgType[0].org;
      });
    },
    /**
     * 获取公司核名所需数据
     */
    getTrademarkParam() {
      getTrademarkParam().then(res => {
        this.$set(this, "trademark_redirect", res.data.trademark_redirect);
      });
    },
    async queryTrademark() {
      const keyword = trim(this.trademark.keyword);
      await this.$validator({
        keyword: [required(required.message("关键字"))]
      })
        .validate({ keyword })
        .then(() => {
          this.$router.push({
            path: "/trademarkSearch/",
            query: { keyword: keyword }
          });
        })
        .catch(e => {
          return validatorDefaultCatch(e);
        });
    },
    async queryCompany() {
      const keyword = trim(this.companyInfo.companyKeyword);
      await this.$validator({
        keyword: [required(required.message("关键字"))]
      })
        .validate({ keyword })
        .then(() => {
          this.$router.push({
            path: "/companySearch/",
            query: {
              keyword: keyword,
              industryType: this.companyInfo.industryType,
              orgType: this.companyInfo.orgType,
              companyCity: this.companyInfo.companyCity
            }
          });
        })
        .catch(e => {
          return validatorDefaultCatch(e);
        });
    },
    // 留言提交
    async messageSubmit() {
      const comment = trim(this.message.comment),
        thisoption = this.thisoption,
        contact = this.message.contact;
      let that = this;
      await this.$validator({
        thisoption: [required("请选择您想了解的服务产品")],
        contact: [
          required("请填写正确手机号码"),
          chs_phone("请填写正确手机号码")
        ]
      })
        .validate({ thisoption, contact })
        .then(() => {
          messageSubmit({
            option: that.option,
            contact: that.message.contact,
            comment: comment
          })
            .then(res => {
              that.thisoption = "";
              that.message.contact = "";
              that.$dialog.success(res.msg);
            })
            .catch(err => {
              that.$dialog.error(err.msg);
            });
        })
        .catch(e => {
          return validatorDefaultCatch(e);
        });
    },
    //获取点击对象 赋予class名称
    addClass: function(index) {
      this.current = index; //获取点击对象
    },
    // 轮播图跳转
    goUrl(index) {
      let url = this.banner[index].wap_url;
      let newStr = url.indexOf("http") === 0;
      if (newStr) {
        window.location.href = url;
      } else {
        this.$router.push({
          path: url
        });
      }
    }
  }
};
</script>
<style scoped>
[v-cloak] {
  display: none;
}
.index {
  background-color: #fff;
}
.index .follow {
  z-index: 100000;
}
.keep {
  text-align: center;
}
/* 为了覆盖样式我容易吗 */
.write_what .xiba_code {
  padding: 0;
}
.slider-right-item {
  width: 400px;
}
.card-wrapper .card.big .card-desc:nth-child(2) {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.card-wrapper .card.big .card-desc:nth-child(3) {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.ticp-icon-hangyeneigaoxingjiabi img {
  weight: 58px;
  height: 62px;
}
.home-title {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-flow: column;
  align-items: center;
}
.home-title-big {
  font-size: 38px;
}
</style>
<style>
.trade-com .ivu-tabs-bar {
  display: none;
}
</style>
